/**
 * receives a string and strips its non alphanumeric characters
 *
 * @param { String } text
 * @param { String } id
 * @return a lowercase alphanumeric string
 */
export function textToId(text) {
  const spaces = new RegExp(/\s/g);
  const anythingButSpacesAndLetters = /[^\sA-Z0-9]/gi;
  const punctuationToStrip = new RegExp(anythingButSpacesAndLetters);
  const id = text?.toLowerCase().replace(punctuationToStrip, "").replace(spaces, "-");
  return id;
}
